import React, { useState } from 'react';
import { DashboardVisibilityIcon, SalesTrackingIcon } from '../icons/OnboardingIcons';

const DashboardVisibilityStep = ({ onNext, onBack }) => {
  const [pages, setPages] = useState([
    {
      id: 'dashboard',
      icon: <SalesTrackingIcon color="#df3836" />,
      title: 'Dashboard',
      description: 'Main overview and analytics',
      enabled: true,
    },
    {
      id: 'members',
      icon: <SalesTrackingIcon color="#df3836" />,
      title: 'Members',
      description: 'Member management and profiles',
      enabled: true,
    },
    {
      id: 'trainers',
      icon: <SalesTrackingIcon color="#df3836" />,
      title: 'Trainers',
      description: 'Trainer schedules and performance',
      enabled: true,
    },
    {
      id: 'billing',
      icon: <SalesTrackingIcon color="#df3836" />,
      title: 'Billing',
      description: 'Payments and invoices',
      enabled: true,
    },
    {
      id: 'reports',
      icon: <SalesTrackingIcon color="#df3836" />,
      title: 'Reports',
      description: 'Analytics and reports',
      enabled: true,
    },
    {
      id: 'inventory',
      icon: <SalesTrackingIcon color="#df3836" />,
      title: 'Inventory',
      description: 'Equipment and supplies',
      enabled: false,
    },
    {
      id: 'marketing',
      icon: <SalesTrackingIcon color="#df3836" />,
      title: 'Marketing',
      description: 'Campaigns and promotions',
      enabled: false,
    },
    {
      id: 'settings',
      icon: <SalesTrackingIcon color="#df3836" />,
      title: 'Settings',
      description: 'Configuration options',
      enabled: true,
    },
  ]);

  const togglePage = (pageId) => {
    setPages(pages.map(page =>
      page.id === pageId ? { ...page, enabled: !page.enabled } : page
    ));
  };

  const enabledCount = pages.filter(p => p.enabled).length;
  const totalCount = pages.length;

  return (
    <div className="v2-dashboard-visibility-step">
      <div className="v2-step-header">
        <div className="v2-step-icon v2-step-icon--no-bg">
          <DashboardVisibilityIcon />
        </div>
        <div>
          <h2 className="v2-step-title">Dashboard Page Visibility</h2>
          <p className="v2-step-description">
            Configure which dashboard pages are accessible for the gym. Toggle pages on or off based on the selected plan features.
          </p>
        </div>
      </div>

      <div className="v2-dashboard-visibility__summary">
        <span className="v2-dashboard-visibility__count">
          <strong>{enabledCount}</strong> of {totalCount} pages enabled
        </span>
      </div>

      <div className="v2-dashboard-visibility__grid">
        {pages.map((page) => (
          <div
            key={page.id}
            className={`v2-page-card ${page.enabled ? 'v2-page-card--enabled' : 'v2-page-card--disabled'}`}
          >
            <div className="v2-page-card__content">
              <div className={`v2-page-card__icon ${page.enabled ? 'v2-page-card__icon--enabled' : ''}`}>
                <span className="v2-page-card__emoji">{page.icon}</span>
              </div>
              <div className="v2-page-card__info">
                <h4 className="v2-page-card__title">{page.title}</h4>
                <p className="v2-page-card__description">{page.description}</p>
              </div>
            </div>
            <div className="v2-page-card__toggle">
              <button
                type="button"
                className={`v2-toggle ${page.enabled ? 'v2-toggle--active' : ''}`}
                onClick={() => togglePage(page.id)}
                aria-label={`Toggle ${page.title}`}
              >
                <span className="v2-toggle__slider"></span>
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="v2-dashboard-visibility__note">
        <strong>Note:</strong> Disabled pages will not be visible to gym owners in their dashboard. You can always enable them later from the onboarded gym settings.
      </div>
    </div>
  );
};

export default DashboardVisibilityStep;
